import { Button } from "@/components/ui/baseUi/button"
import { Text } from "@/components/ui/baseUi/text"
import { word } from "@/modules/core/utils/i18n"
import { ReactionDisplay } from "@/modules/social/components/reactionDisplay"
import { SocialReactionPicker } from "@/modules/social/components/socialReactionPicker"
import { SocialPostResumeLightEntity } from "@/modules/social/entities/socialEntity"
import { useToggleSocialReaction } from "@/modules/social/hooks/useSocialReactions"
import { useSocialSidebar } from "@/modules/social/hooks/useSocialSidebar"
import { createSocialPostModel } from "@/modules/social/models/socialPostModel"
import { MessageCircle } from "lucide-react"

type SocialCardProps = {
  socialPostId: string | null
  sessionInfos: { id: string; name: string }
  socialResume: SocialPostResumeLightEntity | null
}

export const SocialCard = ({ socialPostId, sessionInfos, socialResume }: SocialCardProps) => {
  const { navigateToSocialView } = useSocialSidebar()
  const { addReaction, removeReaction, isPending } = useToggleSocialReaction({
    socialPostId: socialPostId ?? null,
    sessionId: sessionInfos.id,
    userId: null,
    exerciseId: null,
  })

  const model = socialResume ? createSocialPostModel(socialResume) : null

  return (
    <div className="flex w-full items-center justify-between rounded-3xl bg-linear-to-r from-(--social-card-gradient-from) to-(--social-card-gradient-to) to-200% p-4.5">
      <div className="flex items-center gap-3">
        {model && !model.isEmpty ? (
          <ReactionDisplay
            displayedReactions={model.displayedReactions}
            totalReactions={model.totalReactions}
            commentsNumber={model.totalComments}
          />
        ) : (
          <Text fontStyle="LM" className="text-textOnSurface-default">
            {word("social.reaction.empty")}
          </Text>
        )}
      </div>

      <div className="flex items-center gap-2">
        <SocialReactionPicker
          currentEmoji={model?.currentUserEmoji ?? null}
          onSelect={(emoji) => addReaction(emoji)}
          onRemove={() => removeReaction()}
          disabled={isPending}
        />
        <Button
          variant="secondarySecondary"
          size="iconLg"
          onClick={() => navigateToSocialView(socialPostId, sessionInfos)}
          className="rounded-full text-textOnSurface-default"
        >
          <MessageCircle className="size-6" />
        </Button>
      </div>
    </div>
  )
}
